var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtmp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M12.5 40Q8.2 40 5.1 36.9Q2 33.8 2 29.5Q2 25.6 4.475 22.625Q6.95 19.65 10.85 19.05Q11.85 14.2 15.55 11.125Q19.25 8.05 24.1 8.05Q29.75 8.05 33.575 12.125Q37.4 16.2 37.4 21.9V23.1Q41 23 43.5 25.425Q46 27.85 46 31.55Q46 35 43.5 37.5Q41 40 37.55 40H25.5Q24.3 40 23.4 39.1Q22.5 38.2 22.5 37V24.1L18.35 28.25L16.2 26.1L24 18.3L31.8 26.1L29.65 28.25L25.5 24.1V37Q25.5 37 25.5 37Q25.5 37 25.5 37H37.55Q39.8 37 41.4 35.4Q43 33.8 43 31.55Q43 29.3 41.4 27.7Q39.8 26.1 37.55 26.1H34.4V21.9Q34.4 17.45 31.375 14.25Q28.35 11.05 23.9 11.05Q19.45 11.05 16.4 14.25Q13.35 17.45 13.35 21.9H12.4Q9.3 21.9 7.15 24.075Q5 26.25 5 29.45Q5 32.55 7.2 34.775Q9.4 37 12.5 37H19.5V40ZM24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Q24 25.5 24 25.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtmp);
export default __webpack_public_path__ + "static/media/rtmp.62c30ae0119493070a1c339f20a8d192.svg";
export { ForwardRef as ReactComponent };